import MapCache from 'map-cache'

const heapCacheMap = new MapCache<string, string>()

export default heapCacheMap
